// ============================================================================
// RequireClientAuth — the PORTAL route guard. The mirror of the trainer's
// RequireAuth but bound to the CLIENT realm: while the client session resolves
// it shows a quiet loader; if no client is signed in it redirects to the client
// login (/me/login), preserving the attempted location. A trainer being signed
// in does nothing here — only an active client session passes, so a client (or
// a trainer) can never wander into the wrong app's protected routes.
// ============================================================================
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useClientAuth } from "./ClientAuthContext";
import { FullPageSpinner } from "../../components/FullPageSpinner";
import { CLIENT_LOGIN_PATH } from "../routes";

export function RequireClientAuth() {
  const { isAuthenticated, isLoading } = useClientAuth();
  const location = useLocation();
  const { t } = useTranslation("clientPortal");

  if (isLoading) return <FullPageSpinner label={t("loading")} />;

  if (!isAuthenticated) {
    return (
      <Navigate to={CLIENT_LOGIN_PATH} replace state={{ from: location }} />
    );
  }

  return <Outlet />;
}
